import {
  useQuery,
  useMutation,
  useQueryClient
} from '@tanstack/react-query'

import { jointScenarioQueryKeys } from '../queryKeys'
import { singularResourcefulJointScenarioRequest } from '../requests'

export function useJointBudgetQuery({
  jointScenarioId,
  initialData,
  queryKey,
  additionalInvalidationKeys = []
}) {
  const queryClient = useQueryClient()
  // NOTE: We should contain a list of scenario resources
  // and reference notes from there
  const jointBudgetRequest = singularResourcefulJointScenarioRequest(
    jointScenarioId, 'joint_budget'
  )

  const jointBudgetQuery = useQuery({
    queryFn: jointBudgetRequest.show,
    queryKey,
    initialData
  })

  const updateJointbudgetMutation = useMutation({
    mutationFn: jointBudgetRequest.update,
    onSuccess: async () => {
      queryClient.invalidateQueries({ queryKey: [jointScenarioQueryKeys.jointBudget] })
      await queryClient.invalidateQueries({ queryKey: [jointScenarioQueryKeys.forecast] })
      for (const key of additionalInvalidationKeys) {
        await queryClient.invalidateQueries({ queryKey: [key] })
      }
    },
  })

  const isFetching = jointBudgetQuery.isFetching || updateJointbudgetMutation.isLoading

  const isAnyLoading = jointBudgetQuery.isFetching ||
    updateJointbudgetMutation.isLoading

  return {
    data: jointBudgetQuery.data,
    actions: {
      update: updateJointbudgetMutation.mutateAsync,
    },
    status: jointBudgetQuery.status,

    /* Boolean flags indicating various states of status */
    isFetching: isFetching,
    isAnyLoading: isAnyLoading
  }
}
